import React from 'react';
import ReactLoading from 'react-loading';
import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import ProductVariationListItem from './ProductVariationListItem';
import ProductVariationListItemSkeleton from './ProductVariationListItemSkeleton';

class ProductVariationList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sortBy: '',
            sortDirection: '',
            isAddToCardLoading: {},
            cartQty: {},
        };
    }
    componentDidMount() {
        const { request } = this.props;

        if (request) {
            request();
        }
    }
    setButtonLoading = (key, value) => {
        this.setState({
            isAddToCardLoading: {
                ...this.state.isAddToCardLoading,
                [key]: value,
            },
        });
    };
    setCartQty = (key, value) => {
        this.setState({
            cartQty: {
                ...this.state.cartQty,
                [key]: value,
            },
        });
    };
    setSort(by, direction) {
        this.setState({
            sortBy: by,
            sortDirection: direction,
        });
    }
    toggleSort(e, by) {
        e.preventDefault();

        const newDirection =
            this.state.sortDirection == 'DESC' ? 'ASC' : 'DESC';

        this.setSort(by, newDirection);
    }
    getSortClassName(requestedSortBy) {
        const { sortBy, sortDirection } = this.state;

        if (requestedSortBy == sortBy) {
            return sortDirection == 'ASC' ? 'sort-asc' : 'sort-desc';
        }

        return '';
    }
    getDisplayedList() {
        const { list } = this.props;
        const { sortBy, sortDirection } = this.state;

        let newList = [...list];

        if (sortBy && sortDirection) {
            newList.sort((a, b) => {
                if (sortDirection == 'ASC') {
                    return a[sortBy] > b[sortBy] ? 1 : -1;
                } else {
                    return a[sortBy] < b[sortBy] ? 1 : -1;
                }
            });
        }

        return newList;
    }
    renderLoading() {
        return (
            <React.Fragment>
                <ProductVariationListItemSkeleton />
                <ProductVariationListItemSkeleton />
                <ProductVariationListItemSkeleton />
            </React.Fragment>
        );
    }
    render() {
        const { addToCart, isLoading, loggedIn, currencyFormat, currencyDisplayCode, locale } = this.props;
        const finalList = this.getDisplayedList();

        return (
            <div className='data-table products-data-table'>
                <div className='data-table__header'>
                    <div
                        className='data-table__tr products-data-table-helper__header-row'
                        role='row'
                    >
                        <div className='data-table__th products-data-table-helper__image' />
                        <div
                            className={`data-table__th products-data-table-helper__info ${this.getSortClassName(
                                'Title'
                            )}`}
                            onClick={(e) => this.toggleSort(e, 'Title')}
                        >
                            <span className='data-table__heading'>
                                <LocalizedMessage id={'NAME'} />
                            </span>
                            <span className='data-table__sort-icon' />
                        </div>
                        <div className='data-table__th products-data-table-helper__label' />
                        <div className='data-table__th products-data-table-helper__qty' />
                        <div
                            className={`data-table__th products-data-table-helper__unit-price ${this.getSortClassName(
                                'SalePrice'
                            )}`}
                            onClick={(e) => this.toggleSort(e, 'SalePrice')}
                        >
                            <span className='data-table__heading'>
                                <LocalizedMessage id={'UNIT_PRICE'} />
                            </span>
                            <span className='data-table__sort-icon' />
                        </div>
                        <div
                            className={`data-table__th products-data-table-helper__price ${this.getSortClassName(
                                'SalePrice'
                            )}`}
                        >
                            <span className='data-table__heading'>
                                <LocalizedMessage id={'PRICE'} />
                            </span>
                        </div>
                        <div className='data-table__th products-data-table-helper__action' />
                    </div>
                </div>
                <div className='data-table__body'>
                    {isLoading ? (
                        this.renderLoading()
                    ) : (
                        <React.Fragment>
                            {finalList.map((item) => {
                                const { ID, MinOrderQuantity } = item;

                                return (
                                    <ProductVariationListItem
                                        key={ID}
                                        item={item}
                                        addToCart={addToCart}
                                        cartQty={
                                            this.state.cartQty[ID] ||
                                            MinOrderQuantity ||
                                            1
                                        }
                                        setCartQty={this.setCartQty}
                                        isLoading={
                                            this.state.isAddToCardLoading[ID]
                                        }
                                        setButtonLoading={this.setButtonLoading}
                                        loggedIn={loggedIn}
                                        currencyFormat={currencyFormat}
                                        currencyDisplayCode={currencyDisplayCode}
                                        locale={locale}
                                    />
                                );
                            })}
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

// default props
ProductVariationList.defaultProps = {
    isLoading: false,
    list: [],
};
// validate props
ProductVariationList.propTypes = {
    isLoading: PropTypes.bool,
    list: PropTypes.array,
};

export default ProductVariationList;
